import { useCallback } from 'react';
import { getHomePath } from "../components/utils";
export var useRedirect = function useRedirect(_ref) {
  var slug = _ref.slug,
    viewMode = _ref.viewMode,
    conversationId = _ref.conversationId,
    onHandledUrlClick = _ref.onHandledUrlClick;
  var handleRedirect = useCallback(function (chatId) {
    var HOME_PATH = getHomePath(slug, viewMode);
    if (!HOME_PATH) {
      console.warn('[HanaRecommender] Missing slug or role — redirect aborted.');
      return;
    }
    try {
      var redirectPath = HOME_PATH;
      var targetConversationId = chatId !== null && chatId !== void 0 ? chatId : conversationId;
      if (targetConversationId) {
        if (!redirectPath.endsWith('/')) {
          redirectPath += '/';
        }
        redirectPath += encodeURIComponent(String(targetConversationId));
      }

      // Usamos paths relativos para mantener el dominio personalizado por empresa
      if (onHandledUrlClick) {
        onHandledUrlClick(redirectPath);
      } else {
        window.location.href = redirectPath;
      }
    } catch (err) {
      console.error('[HanaRecommender] Invalid redirect URL:', err);
    }
  }, [slug, viewMode, conversationId, onHandledUrlClick]);
  return {
    handleRedirect: handleRedirect
  };
};